import { TRADE_STATUS } from '~/components/TradeDetail/types'
import IconStatusFail from '~/assets/images/status-fail.svg'
import IconStatusProgress from '~/assets/images/status-progress.svg'
import IconStatusSuccess from '~/assets/images/status-success.svg'
import { ApplicationModal } from '~/state/application/reducer'

export const statusContent = (t) => ({
  [TRADE_STATUS.PENDING]: {
    icon: IconStatusProgress,
    content: {
      [ApplicationModal.CLAIMING]: t('claiming'),
    },
  },
  [TRADE_STATUS.SUCCESS]: {
    icon: IconStatusSuccess,
    content: {
      [ApplicationModal.CLAIMING]: t('claim_success'),
    },
  },
  [TRADE_STATUS.FAILED]: {
    icon: IconStatusFail,
    content: {
      [ApplicationModal.CLAIMING]: t('claim_failed'),
    },
  },
})
